var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"notfound"},[_vm._v("Keine "+_vm._s(_vm.entity)+" gefunden.")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }